import React from "react"
import { Image, Pressable, View } from "react-native"
import CalendarDot from "phosphor-react-native/src/icons/CalendarDot"
import MapPin from "phosphor-react-native/src/icons/MapPin"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H4, H7, Small, SmallBold } from "@/components/standard/BFText"
import type { CommunityEventFragment } from "@/generated/graphql"
import { formatEventDateTime } from "@/screens/events/utils"
import { Card } from "@/components/reusables/ui/card"

interface EventCardProps {
  event: CommunityEventFragment
  onPress?: (event: CommunityEventFragment) => void
}

const EventCard: React.FC<EventCardProps> = ({ event, onPress }) => {
  const isVirtual = event.eventType === "VIRTUAL"

  const handlePress = () => {
    if (onPress) {
      onPress(event)
    }
  }

  return (
    <Pressable
      className="w-full mb-5"
      onPress={handlePress}
      testID={"event-card-" + event.id}
      android_ripple={{ color: "#e0e0e0" }}
      style={({ pressed }) => [{ opacity: pressed ? 0.9 : 1 }]}
    >
      <Card className={"overflow-hidden"}>
        {event.image && (
          <Image
            source={{ uri: event.image }}
            className="w-full aspect-[2/1] bg-gray-200"
            resizeMode="cover"
          />
        )}
        <Vertical className="p-4 pb-5 gap-4">
          <Vertical className="gap-3">
            <H4 className="text-midnight-blue">{event.name}</H4>
            <Vertical className="gap-1">
              <Horizontal className="items-center gap-1">
                <CalendarDot size={14} color="#121F3A" />
                <Small className="text-midnight-blue">
                  {formatEventDateTime(event.startTime)}
                </Small>
              </Horizontal>

              {!isVirtual && event.address && (
                <Horizontal className="items-center gap-1">
                  <MapPin size={14} color="#121F3A" />
                  <Small className="text-midnight-blue">{event.address}</Small>
                </Horizontal>
              )}
            </Vertical>
          </Vertical>

          <Horizontal className="items-center gap-1">
            {isVirtual ? (
              <View className="bg-calm-blue rounded-sm px-1.5 py-0.5">
                <SmallBold className="text-white uppercase text-xs">
                  Virtual
                </SmallBold>
              </View>
            ) : (
              <View className="bg-teal rounded-sm px-1.5 py-0.5">
                <H7 className="text-midnight-blue uppercase text-xs">
                  In Person
                </H7>
              </View>
            )}

            {event.market && (
              <SmallBold className="text-wire-frames-grey text-xs">
                {event.market?.name}
              </SmallBold>
            )}
          </Horizontal>
        </Vertical>
      </Card>
    </Pressable>
  )
}

export default EventCard
